import React from 'react'
import Prop from '../componentes/Prop'

const Contacto = () => {
    return (
        <Prop titulo='CONTÁCTO' icono='material-symbols:mail-sharp' />
    )
}

export default Contacto